module.exports = __webpack_public_path__ + "media/images/icon-thema-complete-f7e8e363dd4d73789fcba22a06d31346.svg";